
import { defineComponent, reactive, toRefs, onMounted, computed } from 'vue';
import TopHeader from '@/components/molecules/TopHeader.vue';
import LoginLayout from '@/components/templates/LoginLayout.vue';
import LoginStepBlowingItem from '@/components/atoms/LoginStepBlowingItem.vue';
import LoginStepBlowingList from '@/components/molecules/LoginStepBlowingList.vue';
import SiteFooter from '@/components/organisms/SiteFooter.vue';
import SiteMap from '@/components/organisms/SiteMap.vue';
import InputItem from '@/components/molecules/InputItem.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import BasicButton from '@/components/atoms/BasicButton.vue';
import LoadingSpinner from '@/components/atoms/LoadingSpinner.vue';
import ArrowSimpleLink from '@/components/atoms/ArrowSimpleLink.vue';
import router from '@/router';
import { useStore } from '@/use/store';
import { AllMutationTypes } from '@/store/mutation-types';
import { EntryParams } from '@/store/interfaces';
import { useRoute } from 'vue-router';
import { useMediaQuery } from '@/composables/mediaQuery';

export default defineComponent({
    /* 新規登録-会員情報の登録 */
    name: 'SignupForm',
    components: {
        TopHeader,
        LoginLayout,
        LoginStepBlowingItem,
        LoginStepBlowingList,
        SiteFooter,
        SiteMap,
        InputItem,
        TextBox,
        BasicButton,
        LoadingSpinner,
        ArrowSimpleLink,
    },

    setup() {
        const store = useStore();
        const route = useRoute();
        const state = reactive({
            isLoading: false,
            params: {
                storeName: '',
                storeNameKana: '',
                unisCustomerCode: '',
                mailAddress: '',
                phoneNumber: '',
                personalInfoConsentFlag: '1',
                membershipAgreementFlag: '1',
                refPath: '',
            },
            isError: false,
            //Validation
            isErrorStoreName: false,
            isErrorStoreNameKana: false,
            isErrorUnisCustomerCode: false,
            isErrorMailAddress: false,
            isErrorPhoneNumber: false,
            sp: computed(() => isSp.value),
        });

        const { isSp, watchMediaQuery } = useMediaQuery();

        onMounted(() => {
            watchMediaQuery();
            store.commit(AllMutationTypes.SET_ENTRY_CHALLENGE_UMID, undefined);
            store.commit(AllMutationTypes.SET_ENTRY_PROVISIONAL_UMID, undefined);
            if (
                (router.options.history.state.back === '/entry/confirm' || router.options.history.state.back === '/entry/code') &&
                store.getters.entryParams
            ) {
                state.params = store.getters.entryParams as EntryParams;
            } else {
                store.commit(AllMutationTypes.SET_ENTRY_PARAMS, undefined);
            }

            if (route.query) {
                console.log(`String: ${JSON.stringify(route.query)} `);
                state.params.refPath = JSON.stringify(route.query);
            }
        });

        const confirm = async () => {
            verify();
            if (state.isError) {
                state.isLoading = false;
                return;
            }
            store.commit(AllMutationTypes.SET_ENTRY_PARAMS, state.params);
            router.push('/entry/confirm');
        };

        const verify = () => {
            state.isErrorStoreName = state.params.storeName === '';
            state.isErrorStoreNameKana = state.params.storeNameKana === '';
            state.isErrorPhoneNumber = state.params.phoneNumber === '';
            state.isErrorMailAddress = state.params.mailAddress === '';
            state.isErrorUnisCustomerCode = state.params.unisCustomerCode === '';

            if (state.params.storeName.length > 101) {
                state.isErrorStoreName = true;
            }
            if (state.params.storeNameKana.length > 101) {
                state.isErrorStoreNameKana = true;
            }
            if (state.params.mailAddress.length > 101) {
                state.isErrorMailAddress = true;
            }

            const regexKana = /^([ァ-ヴー0-9\s!-/:-@[-`{-~]|[ｦ-ﾟ])+$/u;

            if (!regexKana.test(state.params.storeNameKana)) {
                state.isErrorStoreNameKana = true;
            }

            const regexPhone = /^0\d{9,11}$/;
            if (!regexPhone.test(state.params.phoneNumber)) {
                state.isErrorPhoneNumber = true;
            }

            const regexUnisCustomerCode = /^\d{9}$/;
            if (!regexUnisCustomerCode.test(state.params.unisCustomerCode)) {
                state.isErrorUnisCustomerCode = true;
            }

            const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!regexEmail.test(state.params.mailAddress)) {
                state.isErrorMailAddress = true;
            }

            if (
                state.isErrorStoreName ||
                state.isErrorStoreNameKana ||
                state.isErrorMailAddress ||
                state.isErrorUnisCustomerCode ||
                state.isErrorPhoneNumber
            ) {
                state.isError = true;
            } else {
                state.isError = false;
            }
        };

        return {
            ...toRefs(state),
            confirm,
            verify,
        };
    },
});
